// Use $ instead of $ without replacing global $
(function ($) {

  // Video overlay
  function videoOverlay() {
    $(document).on('click', '.play-video', function (e) {
      e.preventDefault();
      $('body').addClass('overlay-active');
      $('.we-video-overlay').addClass('overlay-active');
      var url = $(this).attr('data-src');
      $('.video-overlay').find('iframe').attr('src', url + '?autoplay=1');
    });
    closeVideoOverlay();
  }

  // Close video overlay on outside/close-btn click
  function closeVideoOverlay() {
    // Close video overlay on close button & outside click
    $('.video-overlay').on('click', function () {
      $('.video-overlay').find('iframe').attr('src', '');
      // $('body').removeClass('overlay-active');
      $('.we-video-overlay').removeClass('overlay-active');
    });

    // Prevent closing on video's click 
    $('.video-overlay  iframe').on('click', function (e) {
      e.stopPropagation();
    });
  }

  $(document).ready(function () {
    videoOverlay();
    video_height();
  });

  $(window).on("load scroll resize", function () {
    video_height();
  });
    $(window).on("load", function () {
        $('.we-video-overlay .video-overlay').removeClass("hide");
    });

  function video_height() {
    var windowheight = $(window).height() / 1.9,
      windowWidth = $(window).width() / 1.2
    $('.video-overlay iframe').attr('width', windowWidth + 'px');
    $('.video-overlay iframe').attr('height', windowheight + 'px');
  }

})(jQuery);